const RELOAD_IMAGE_TIMEOUT = [1000, 2000, 2000, 4000, 4000, 8000, 8000, 16000, 16000, 32000];

export {RELOAD_IMAGE_TIMEOUT};
